export const API_ROUTES = {
  License: {
    LicensesType: '/api/licenses/lookups/types',
    Licenses: '/api/licenses',
    ActionType: (id) => `/api/licenses/${id}/actions`,
    License: (id) => `/api/licenses/${id}`
  },
  LicenseTermination: {
    termination:(id)=> `/api/licensetermination/submit/${id}`,
    Update:"/api/licensetermination/Update"  
  },
  Company: {
    All: '/api/company/all',
    Pagination: '/api/company/pagination',
    Update: '/api/company/SDIFCallback'
  },
  Lookups: {
    ComplianceStatuses: '/api/lookups/compliance-statuses',
    Levels: '/api/lookups/Levels',
    Roles: `/api/Lookups/GetRoles`,
  },

  
  DigitalTrust: {
    GetDigitalTrustLicenseTypes: '/api/DigitalTrust/GetDigitalTrustLicenseType'
  }
}

